import {Component} from '@angular/core';

@Component({
    selector: 'app-application-container',
    templateUrl: './application-container.component.html',
    styleUrls: ['./application-container.component.scss'],
})
export class ApplicationContainerComponent {
    constructor() {}
}
